export default "__VITE_ASSET__DYJgPwx3__"